import { useTableSubviewState } from './table-subview-state-provider';
import { TableSubviewButtonProps, TableSubviewQuantityType } from './table-subview.types';
import { CircleInfoIcon, Popover } from '../..';
import { FormattedNumber, FormattedNumberProps } from '../formatted-number/formatted-number';

const baseStyles = {
  button: 'px-4 py-2 border-t border-x border-b-2 rounded-lg grow shrink w-0',
  text: 'text-left font-semibold text-sm text-clip whitespace-nowrap fill-current',
  quantity: {
    container: 'text-left mt-1',
    number: 'text-md font-medium',
    unit: 'text-sm',
  },
};

const selectedStyles = {
  button: `${baseStyles.button} bg-jungle-50 border-primary`,
  text: `${baseStyles.text} text-jungle-800`,
  quantity: {
    container: `${baseStyles.quantity.container}`,
    number: `${baseStyles.quantity.number} text-jungle-900`,
    unit: `${baseStyles.quantity.unit} text-primary`,
  },
};

const unselectedStyles = {
  button: `${baseStyles.button} bg-white border-transparent hover:bg-gray-50`,
  text: `${baseStyles.text} text-gray-800`,
  quantity: {
    container: `${baseStyles.quantity.container}`,
    number: `${baseStyles.quantity.number} text-gray-900`,
    unit: `${baseStyles.quantity.unit} text-gray-700`,
  },
};

const formatQuantity = (quantity: number, quantityType: TableSubviewQuantityType) => {
  const options =
    quantityType === 'currency'
      ? ({ style: 'currency', currency: 'USD', notation: 'compact' } as FormattedNumberProps)
      : {};
  return <FormattedNumber {...options}>{quantity}</FormattedNumber>;
};

export const TableSubviewButton = (props: TableSubviewButtonProps) => {
  const { id, text, description, quantity, unitOfMeasure, quantityType = 'unit', quantityTextOverride } = props;
  const { selectedId, onSelectionChanged } = useTableSubviewState();

  const styles = selectedId === id ? selectedStyles : unselectedStyles;
  const formatted = quantityTextOverride ?? formatQuantity(quantity, quantityType);

  return (
    <button className={styles.button} onClick={() => onSelectionChanged(id)}>
      <div className={styles.text}>
        {text}{' '}
        <Popover
          placement="top"
          trigger="hover"
          offsetOptions={{ mainAxis: 5, crossAxis: 6 }}
          arrowPointAtCenter={true}
          content={<div className="w-72">{description}</div>}
        >
          <CircleInfoIcon className="mb-px inline-block size-4" />
        </Popover>
      </div>
      <div className={styles.quantity.container}>
        <span className={styles.quantity.number}>{formatted}</span>
        <span className={styles.quantity.unit}> {unitOfMeasure}</span>
      </div>
    </button>
  );
};
